import { SERVER_SIDE_GTM_FINISHED_BOOKING } from "@config/endpoints";

import { AsyncActionResult } from "@services/AsyncActionCreatorFactory";
import { ASYNC_ACTION_TYPES } from "@services/FetchFacade";
import { buildUrl } from "@services/BuildUrl";

import { useFeatureToggle } from "@hooks/useFeatureToggle";

import { asyncActionCreator } from "@app/services/AsyncActionCreator";

export const useServerSideGTM = () => {
  const isGTMEnabled = useFeatureToggle("gtm");

  const sendFinishedBooking = async (
    reservationUuid: string,
    body: {
      pageUrl: string;
    },
  ): Promise<AsyncActionResult | null> => {
    if (!isGTMEnabled) {
      return null;
    }

    const requestURL = buildUrl(SERVER_SIDE_GTM_FINISHED_BOOKING)
      .setPath("reservationUuid", reservationUuid)
      .done();

    return asyncActionCreator({
      action: "",
      method: ASYNC_ACTION_TYPES.POST,
      url: requestURL,
      body,
    });
  };

  return {
    sendFinishedBooking,
  };
};
